import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { baseQuery, createQueryString, getToken } from "../utility/helper";

export const sectionalCategoryApi = createApi({
  reducerPath: "sectionalCategory",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = getToken();
      if (token) headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  tagTypes: ["sectionalCategory"],
  endpoints: (builder) => ({
    createSectionalCategory: builder.mutation({
      query: (formData) => ({
        url: "/sectional-category",
        method: "POST",
        body: formData,
      }),
      // onQueryStarted: async (newSectionalCategory, { dispatch, queryFulfilled }) => {
      //   const patchResult = dispatch(
      //     sectionalCategoryApi.util.updateQueryData("getSectionalCategorys", undefined, (draft) => {
      //       draft.push(newSectionalCategory);
      //     })
      //   );
      //   try {
      //     await queryFulfilled;
      //   } catch {
      //     patchResult.undo();
      //   }
      // },
      invalidatesTags: ["sectionalCategory"],
    }),

    updateSectionalCategory: builder.mutation({
      query: ({ id, formData }) => ({
        url: `/sectional-category/${id}`,
        method: "PATCH",
        body: formData,
      }),
      invalidatesTags: ["sectionalCategory"],
    }),

    deleteSectionalCategory: builder.mutation({
      query: (id) => ({ url: `/sectional-category/${id}`, method: "DELETE" }),
      invalidatesTags: ["sectionalCategory"],
    }),

    getSectionalCategories: builder.query({
      query: ({ page = 1, perPage = 10, keyword = "" }) => {
        const params = {
          options: {
            query: {},
            page,
            limit: perPage,
            populate: [
              {
                dir: "users",
                path: "createdBy",
                select: "_id username",
              },
            ],
          },
        };

        const serializedParams = createQueryString(params);

        return `/sectional-category?${serializedParams}`;
      },
      providesTags: ["sectionalCategory"],
    }),
  }),
});

export const {
  useGetSectionalCategoriesQuery,
  useCreateSectionalCategoryMutation,
  useUpdateSectionalCategoryMutation,
  useDeleteSectionalCategoryMutation,
} = sectionalCategoryApi;
